module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av720-e058f7175be84fcc0f3ecb2b0d0d3fdc.jpg";